
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

export const EmailChangeInfo = () => {
  return null;
};

